module.exports = __webpack_public_path__ + "static/media/thacks.41576612.png";